import { omitBy } from 'lodash';
import request from '../../../request/request';

const getGroups = ({ page, size, keyword, privilegedOnly }) => {
  return request({
    url: `/webapi/groups`,
    params: omitBy(
      {
        page: page - 1,
        size,
        keyword,
        privilegedOnly,
        includeHidden: false
      },
      value =>
        value === undefined || value === null || value.toString().trim() === ''
    )
  });
};

const createGroup = ({ name, description }) => {
  return request({
    url: '/webapi/group/create',
    method: 'POST',
    data: { name, description }
  });
};

export { getGroups, createGroup };
